import {Injectable} from '@angular/core';
import {ProductActions, ProductSearchService, SearchConfig} from '@spartacus/core';

/**
 * Sparacus search method checks for an empty query string which results in or search page being empty instead of listing all products
 */
@Injectable({
  providedIn: 'root'
})
export class DcpProductSearchService extends ProductSearchService {
  search(query: string | undefined, searchConfig?: SearchConfig): void {
    this.store.dispatch(
      new ProductActions.SearchProducts({
        queryText: query,
        searchConfig,
      })
    );
  }
}
